'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInstantsearchCore = require('react-instantsearch-core');

var _utils = require('../core/utils');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = (0, _utils.createClassNames)('NumericMenu');

var NumericMenu = function (_Component) {
  _inherits(NumericMenu, _Component);

  function NumericMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumericMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumericMenu.__proto__ || Object.getPrototypeOf(NumericMenu)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item) {
      var _this$props = _this.props,
          refine = _this$props.refine,
          translate = _this$props.translate;


      return _react2.default.createElement(
        'label',
        { className: cx('label') },
        _react2.default.createElement('input', {
          className: cx('radio'),
          type: 'radio',
          checked: item.isRefined,
          disabled: item.noRefinement,
          onChange: function onChange() {
            return refine(item.value);
          }
        }),
        _react2.default.createElement(
          'span',
          { className: cx('labelText') },
          item.value === '' ? translate('all') : item.label
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumericMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          canRefine = _props.canRefine,
          className = _props.className;


      return _react2.default.createElement(_List2.default, {
        renderItem: this.renderItem,
        showMore: false,
        canRefine: canRefine,
        cx: cx,
        items: items.map(function (item) {
          return _extends({}, item, { key: item.value });
        }),
        className: className
      });
    }
  }]);

  return NumericMenu;
}(_react.Component);

NumericMenu.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.node.isRequired,
    value: _propTypes2.default.string.isRequired,
    isRefined: _propTypes2.default.bool.isRequired,
    noRefinement: _propTypes2.default.bool.isRequired
  })).isRequired,
  canRefine: _propTypes2.default.bool.isRequired,
  refine: _propTypes2.default.func.isRequired,
  translate: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string
};
NumericMenu.defaultProps = {
  className: ''
};
exports.default = (0, _reactInstantsearchCore.translatable)({
  all: 'All'
})(NumericMenu);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/NumericMenu.js
// module id = 1060
// module chunks = 142807904292071